import React from "react";
export const OrderHistory = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.308 1.00001H10.829C10.8863 1.00001 10.9433 1.00367 11 1.01101C13.2473 1.16817 14.9924 3.0332 15 5.28601V11.715C14.9917 14.0871 13.0641 16.0044 10.692 16H5.308C2.93551 16.0044 1.00772 14.0865 1 11.714V5.28601C1.00772 2.91353 2.93551 0.995581 5.308 1.00001Z"
        stroke="#775FD5"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15 6.03672C15.4142 6.03672 15.75 5.70093 15.75 5.28672C15.75 4.87251 15.4142 4.53672 15 4.53672V6.03672ZM11 5.28672H10.25C10.25 5.70093 10.5858 6.03672 11 6.03672V5.28672ZM11.75 1.01172C11.75 0.597505 11.4142 0.261719 11 0.261719C10.5858 0.261719 10.25 0.597505 10.25 1.01172H11.75ZM10 9.75072C10.4142 9.75072 10.75 9.41493 10.75 9.00072C10.75 8.5865 10.4142 8.25072 10 8.25072V9.75072ZM4 8.25072C3.58579 8.25072 3.25 8.5865 3.25 9.00072C3.25 9.41493 3.58579 9.75072 4 9.75072V8.25072ZM7 6.75072C7.41421 6.75072 7.75 6.41493 7.75 6.00072C7.75 5.5865 7.41421 5.25072 7 5.25072V6.75072ZM4 5.25072C3.58579 5.25072 3.25 5.5865 3.25 6.00072C3.25 6.41493 3.58579 6.75072 4 6.75072V5.25072ZM11 12.7507C11.4142 12.7507 11.75 12.4149 11.75 12.0007C11.75 11.5865 11.4142 11.2507 11 11.2507V12.7507ZM4 11.2507C3.58579 11.2507 3.25 11.5865 3.25 12.0007C3.25 12.4149 3.58579 12.7507 4 12.7507V11.2507ZM15 4.53672H11V6.03672H15V4.53672ZM11.75 5.28672V1.01172H10.25V5.28672H11.75ZM10 8.25072H4V9.75072H10V8.25072ZM7 5.25072H4V6.75072H7V5.25072ZM11 11.2507H4V12.7507H11V11.2507Z"
        fill="#775FD5"
      />
    </svg>
  );
};
